module.exports = __webpack_public_path__ + "img/R.3492960.webp";